import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/card.module.scss'
import classNames from 'classnames'

type Props = {
  dataCy?: string
  isOutlined?: boolean
  disabled?: boolean
  isGrey?: boolean
  children: ReactNode
}

const Card: FC<Props> = (props) => {
  const { children, dataCy, isOutlined, disabled, isGrey } = props

  const dataCyStr = dataCy ? `card-${dataCy}` : 'card'

  return (
    <article
      className={classNames({
        [styles.basic_outlined]: isOutlined && !disabled && !isGrey,
        [styles.basic_disabled]: !isOutlined && disabled && !isGrey,
        [styles.basic_grey]: !isOutlined && !disabled && isGrey,
        [styles.basic]: !isOutlined && !disabled && !isGrey,
      })}
      data-cy={dataCyStr}
    >
      {children}
    </article>
  )
}

export default Card
